/**
 * NOTE:
 * Currently there is no BE service that holds the image mapping for each indicator.
 * For now, we use the lowercased indicator name as the key.
 * If possible, use better approach.
 */
export const INDICATOR_IMAGES: Record<string, string> = {
  'keteraturan suasana kelas':
    '/illustrations/img-chalk-board-teach-character-stundet.png',
  'penerapan disiplin positif': '/illustrations/img-flow-process.png',
  'ekspektasi pada peserta didik': '/illustrations/img-book-rapor-graphic.png',
  'perhatian dan kepedulian': '/illustrations/img-heart-empathic-give.png',
  'umpan balik konstruktif': '/illustrations/img-chat-talk.png',
  'instruksi yang adaptif': '/illustrations/img-assessment-subject-book.png',
  'instruksi pembelajaran': '/illustrations/img-chalk-board.png',
  'aktivitas interaktif': '/illustrations/img-curation-cards-screen.png',
}
